var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-toast-editor',{ref:_vm.dynamicRef,attrs:{"id":_vm.dynamicRef,"initialValue":_vm.value,"options":_vm.editorOptions,"initialEditType":"wysiwyg","previewStyle":"vertical","height":_vm.height},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }